import PropTypes from "prop-types";
import React from "react";
import { Box } from "signoxe/components/layout";
import { MainMenu } from "signoxe/components/widgets";
import { NotificationPropType } from "signoxe/constants/propTypes";
import logo from "signoxe/logo.png";
import mobileLogo from "signoxe/images/logomobile.png";
import "./styles.scss";

class Header extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    console.log("Header Logo", this.props.logo)
    const {
      title,
      username,
      profile,
      notifications,
      unreadNotificationCount,
      fetching,
      onMarkAllNotificationsRead,
      onToggleUploadsTray,
      onLogout,
      onHelp,
      onRefresh,
      reportNavActive,
    } = this.props;

    return (
      <Box
        tag="header"
        direction="row"
        className="theme-background"
        justifyContent="flex-end"
        alignItems="center"
      >
        <img
          className="logo-mobile show-for-small"
          src={this.props.mobile_logo || mobileLogo}
          alt="logo"
        />
        <img className="logo show-for-medium" src={this.props.logo || logo} alt="logo" />
        <h3 className="show-for-large">{title}</h3>
        <MainMenu
          username={username}
          profile={profile}
          notifications={notifications}
          unreadNotificationCount={unreadNotificationCount}
          fetching={fetching}
          onClickUploads={onToggleUploadsTray}
          onMarkAllNotificationsRead={onMarkAllNotificationsRead}
          onClickLogout={onLogout}
          onClickHelp={onHelp}
          onClickRefresh={onRefresh}
          reportNavActive={reportNavActive}
        />
      </Box>
    );
  }
}

Header.propTypes = {
  title: PropTypes.string.isRequired,
  notifications: PropTypes.arrayOf(NotificationPropType).isRequired,
  unreadNotificationCount: PropTypes.number,
  username: PropTypes.string.isRequired,
  fetching: PropTypes.bool.isRequired,
  onMarkAllNotificationsRead: PropTypes.func.isRequired,
  onToggleUploadsTray: PropTypes.func.isRequired,
  onLogout: PropTypes.func.isRequired,
  onHelp: PropTypes.func.isRequired,
  onRefresh: PropTypes.func.isRequired,
  profile: PropTypes.object.isRequired,
};

export default Header;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/Header/index.js